import React from 'react';
import './style.scss';

// Sizes: small, medium, large, xlarge
function Spinner({size="small", centered, className}) {
  const iconClass = [
    "Spinner__icon",
    "Spinner__icon--" + size,
    className ?? "",
  ].join(" ");

  return (
    <span className={`Spinner ${centered ? "Spinner--centered" : ""}`}>
      <svg
        className={iconClass}
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
      </svg>
    </span>
  );
}

export default Spinner;